if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      e420ResetSelectedVariant() {
        let e420SelectedVariantId = document.querySelector(
          'input[name="e420-selected-variant-id"]'
        );
        let e420SelectedTitle = document.querySelector(
          'input[name="e420-selected-title"]'
        );
        let e420SelectedVariantTitle = document.querySelector(
          'input[name="e420-selected-variant-title"]'
        );
        let e420SelectedVariantType = document.querySelector(
          'input[name="e420-selected-variant-type"]'
        );
        let e420SelectedVariantVendor = document.querySelector(
          'input[name="e420-selected-variant-vendor"]'
        );
        let e420SelectedVariantPrice = document.querySelector(
          'input[name="e420-selected-variant-price"]'
        );
        let e420SelectedVariantSKU = document.querySelector(
          'input[name="e420-selected-variant-sku"]'
        );
        let e420SelectedVariantQuantity = document.querySelector(
          'input[name="e420-selected-variant-quantity"]'
        );
        // Reset all values
        if (e420SelectedVariantId) {
          e420SelectedVariantId.value = "";
        }
        if (e420SelectedTitle) {
          e420SelectedTitle.value = "";
        }
        if (e420SelectedVariantTitle) {
          e420SelectedVariantTitle.value = "";
        }
        if (e420SelectedVariantType) {
          e420SelectedVariantType.value = "";
        }
        if (e420SelectedVariantVendor) {
          e420SelectedVariantVendor.value = "";
        }
        if (e420SelectedVariantPrice) {
          e420SelectedVariantPrice.value = "";
        }
        if (e420SelectedVariantSKU) {
          e420SelectedVariantSKU.value = "";
        }
        if (e420SelectedVariantQuantity) {
          e420SelectedVariantQuantity.value = 1;
        }
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
        this.e420ResetSelectedVariant();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener
          .querySelector(".loading-overlay__spinner")
          .classList.remove("hidden");

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            );
            if (!this.productElement)
              throw new Error("QuickAdd: Main product section not found");
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            // E420 CUSTOM CODE for creating more compact layout
            // SAFER: price element might not exist on some templates (e.g., flower)
            const sectionId = this.productElement?.dataset?.section;

            // Try multiple selectors in order of specificity
            const priceElement =
              (sectionId &&
                this.productElement.querySelector(
                  `#price-quickadd-${sectionId}`
                )) ||
              (sectionId &&
                this.productElement.querySelector(`#price-${sectionId}`)) ||
              this.productElement.querySelector('[id^="price-quickadd-"]') ||
              this.productElement.querySelector('[id^="price-"]') ||
              this.productElement.querySelector(".price"); // final fallback

            if (
              priceElement
                ?.querySelector(".price-item--regular")
                ?.classList.contains("e420-regular-price")
            ) {
              this.productElement
                .querySelector(".e420-wishlist-and-reviews-container")
                ?.classList.add("wishlist-remove-float");
            }

            // E420 CUSTOM CODE For Shipping Text and Discount adding quick add class
            const expectedTimeTitle =
              this.productElement.querySelector(".e420-expectedTime");
            const discountCode = this.productElement.querySelector(
              ".e420-product-discount-code__wrapper"
            );
            expectedTimeTitle?.classList.add("e420-expectedTime--quick-add");
            discountCode?.classList.add(
              "e420-product-discount-code__wrapper--quick-add"
            );
            // E420 CUSTOM CODE For Shipping Text and Discount adding quick add class END
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            // Re-init E420 swatch dropdowns & legends inside the modal, if available
            if (window.e420InitSwatchDropdowns) {
              window.e420InitSwatchDropdowns(this.modalContent);
            }
            if (window.e420SyncSwatchLegends) {
              window.e420SyncSwatchLegends(this.modalContent);
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
            // E420 CUSTOM CODE For Swatch Elements
            var swatches =
              this.modalContent.querySelectorAll(".swatch-element");
            if (swatches.length > 0) {
              swatches.forEach(function (swatch) {
                // Add event listener to each swatch
                swatch.addEventListener("click", function () {
                  // Get title attribute of the swatch
                  var swatchTitle = swatch.getAttribute("value");
                  // find parent fieldset element of swatch
                  var fieldset = swatch.closest("fieldset");
                  // find legend element with e420-label-selected-value class in fieldset
                  var legend = fieldset.querySelector(
                    "legend span.e420-label-selected-value"
                  );
                  // Set the text of the span to the title attribute of the swatch
                  legend.innerText = " " + swatchTitle;
                });
              });
            }
            // E420 CUSTOM CODE For Swatch Elements END
            // E420 CUSTOM CODE On change of quantity input change the value of all quantity inputs
            const qunatity_Input = this.modalContent.querySelectorAll(
              ".e420-product-form__quantity"
            );
            const e420GA4SelectedVariantQuantityInput = document.querySelector(
              'input[name="e420-selected-variant-quantity"]'
            );
            if (e420GA4SelectedVariantQuantityInput) {
              e420GA4SelectedVariantQuantityInput.value = 1;
            }
            qunatity_Input &&
              qunatity_Input.forEach((qty) => {
                qty.addEventListener("change", function () {
                  const value = this.value;
                  qunatity_Input.forEach((qty_inputs) => {
                    qty_inputs.value = value;
                    if (e420GA4SelectedVariantQuantityInput) {
                      e420GA4SelectedVariantQuantityInput.value = value;
                      e420GA4SelectedVariantQuantityInput.dispatchEvent(
                        new Event("change")
                      );
                    }
                  });
                });
              });
            // E420 CUSTOM CODE On change of quantity input change the value of all quantity inputs END

            // E420 CUSTOM CODE For Discount Code
            function copyToClipboard(element) {
              // Create a temporary textarea element to copy the text to clipboard
              var tempTextarea = document.createElement("textarea");
              // Set the value of the temporary textarea to the value of the input element
              tempTextarea.value = element.value;
              // Add the temporary textarea to the document
              document.body.appendChild(tempTextarea);
              // Select the contents of the temporary textarea
              tempTextarea.select();
              // Copy the selected text to clipboard
              document.execCommand("copy");
              // Remove the temporary textarea from the document
              document.body.removeChild(tempTextarea);
            }
            let copyButton = this.modalContent.querySelectorAll(
              ".e420-product-discount-code__wrapper"
            );

            copyButton.forEach(function (element) {
              element.addEventListener("click", function () {
                let collectionDiscountCode = element?.querySelector(
                  'input[name="e420-input__collection_discount_code"]'
                );
                let clearanceDiscountCode = element?.querySelector(
                  'input[name="e420-input__clearance_discount_code"]'
                );
                let saleMode_couponCode1 = element?.querySelector(
                  'input[name="e420-input__sale_mode_product_coupon_code_1"]'
                );
                let saleMode_couponCode2 = element?.querySelector(
                  'input[name="e420-input__sale_mode_product_coupon_code_2"]'
                );
                let saleMode_couponCode3 = element?.querySelector(
                  'input[name="e420-input__sale_mode_product_coupon_code_3"]'
                );

                if (collectionDiscountCode) {
                  copyToClipboard(collectionDiscountCode);
                  let successMessage = element.querySelector(
                    ".e420-product-discount-code__success_message"
                  );
                  successMessage.classList.add(
                    "e420-product-discount-code__success_message--active"
                  );
                  setTimeout(function () {
                    successMessage.classList.remove(
                      "e420-product-discount-code__success_message--active"
                    );
                  }, 2000);
                }

                if (clearanceDiscountCode) {
                  copyToClipboard(clearanceDiscountCode);
                  let successMessage = element.querySelector(
                    ".e420-product-discount-code__success_message"
                  );
                  successMessage.classList.add(
                    "e420-product-discount-code__success_message--active"
                  );
                  setTimeout(function () {
                    successMessage.classList.remove(
                      "e420-product-discount-code__success_message--active"
                    );
                  }, 2000);
                }

                if (saleMode_couponCode1) {
                  copyToClipboard(saleMode_couponCode1);
                  let successMessage = element.querySelector(
                    ".e420-product-discount-code__success_message"
                  );
                  successMessage.classList.add(
                    "e420-product-discount-code__success_message--active"
                  );
                  setTimeout(function () {
                    successMessage.classList.remove(
                      "e420-product-discount-code__success_message--active"
                    );
                  }, 2000);
                }

                if (saleMode_couponCode2) {
                  copyToClipboard(saleMode_couponCode2);
                  let successMessage = element.querySelector(
                    ".e420-product-discount-code__success_message"
                  );
                  successMessage.classList.add(
                    "e420-product-discount-code__success_message--active"
                  );
                  setTimeout(function () {
                    successMessage.classList.remove(
                      "e420-product-discount-code__success_message--active"
                    );
                  }, 2000);
                }
              });
            });
            // E420 CUSTOM CODE For Discount Code END

            // E420 CUSTOM CODE For Setting GA4 Product Data
            const productInfo = this.modalContent.querySelector("product-info");
            const productInfoDataUrl = productInfo.getAttribute("data-url");
            fetch(productInfoDataUrl + ".json")
              .then((response) => response.json())
              .then((data) => {
                let e420SelectedVariantType = document.querySelector(
                  'input[name="e420-selected-variant-type"]'
                );
                let e420SelectedVariantVendor = document.querySelector(
                  'input[name="e420-selected-variant-vendor"]'
                );

                if (e420SelectedVariantType) {
                  e420SelectedVariantType.value = data.product.product_type;
                  e420SelectedVariantType.dispatchEvent(new Event("change"));
                }
                if (e420SelectedVariantVendor) {
                  e420SelectedVariantVendor.value = data.product.vendor;
                  e420SelectedVariantVendor.dispatchEvent(new Event("change"));
                }
              })
              .catch((error) => {
                console.error("E420 Error:", error);
              });
            // E420 CUSTOM CODE For Setting GA4 Product Data END
            if (typeof window.sdvarLoadFullCss === "function") {
              window.sdvarLoadFullCss();
            }
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener
              .querySelector(".loading-overlay__spinner")
              .classList.add("hidden");
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector(
          "variant-radios,variant-selects"
        );
        if (!variantPicker) return;

        variantPicker.setAttribute("data-update-url", "false");
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector(
          "pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const modalDialog =
          this.productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios, product-info")
          .forEach((element) => {
            element.dataset.originalSection = sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "395px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes)
        );
      }
    }
  );
}
